export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const FETCH_CASES_REQUEST = 'FETCH_CASES_REQUEST'
export const FETCH_CASES_SUCCESS = 'FETCH_CASES_SUCCESS'
export const FETCH_CASES_FAILURE = 'FETCH_CASES_FAILURE'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
